export default "__VITE_ASSET__BKc_V5ew__"